import XAutoGrowTextarea from '../common/XAutoGrowTextarea';
import {
  providerErrorClasses,
  providerInputClasses,
  providerInputInvalidClasses,
  providerInputMinHeight,
} from './demandStudioMedicalBillsClasses';

const DemandStudioProviderNameCell = ({
  value,
  error,
  onChange,
  onBlur,
  onKeyDown,
}) => (
  <>
    <XAutoGrowTextarea
      singleLine
      value={value}
      minHeight={providerInputMinHeight}
      className={`${providerInputClasses} ${error ? providerInputInvalidClasses : ''}`}
      onChange={onChange}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      aria-label="Provider name"
      aria-invalid={Boolean(error)}
    />
    {error && <span className={providerErrorClasses}>{error}</span>}
  </>
);

export default DemandStudioProviderNameCell;
